import React from 'react';
import { useNavigate } from 'react-router-dom';
import TokenCostBadge, { canAfford } from './TokenCostBadge';

interface ConsultCardProps {
  icon: string;
  title: string;
  subtitle?: string;
  /** Rota de destino quando o saldo cobre o custo. */
  to: string;
  cost?: number;
  /** true quando a consulta é gratuita agora (ex.: Tarot do Dia com promoção ativa). */
  free?: boolean;
  balance?: number;
  size?: 'lg' | 'md';
}

/**
 * Card de consulta reutilizável: mostra o custo em tokens e, quando o saldo
 * não cobre, fica em estado desabilitado (opacidade reduzida) e redireciona
 * para a compra de tokens em vez do destino normal.
 */
const ConsultCard: React.FC<ConsultCardProps> = ({ icon, title, subtitle, to, cost = 1, free = false, balance, size = 'md' }) => {
  const navigate = useNavigate();
  const affordable = canAfford(balance, cost, free);
  const isLg = size === 'lg';

  return (
    <button
      onClick={() => navigate(affordable ? to : '/checkout')}
      className={`flex flex-col items-center gap-1.5 text-center rounded-2xl transition-all duration-200 overflow-hidden ${isLg ? 'p-4 sm:p-5 min-h-[112px]' : 'p-3 sm:p-4 min-h-[92px]'} justify-center ${affordable ? 'hover:scale-105' : ''}`}
      style={{
        background: affordable ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.02)',
        border: `1px solid ${affordable ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.05)'}`,
        opacity: affordable ? 1 : 0.55,
      }}
    >
      <span className={isLg ? 'text-3xl flex-shrink-0' : 'text-2xl flex-shrink-0'}>{icon}</span>
      <span className={`font-semibold text-white/85 leading-tight w-full line-clamp-2 ${isLg ? 'text-sm' : 'text-xs'}`}>{title}</span>
      {subtitle && <span className="text-[11px] text-white/40 leading-snug w-full line-clamp-2">{subtitle}</span>}
      {affordable
        ? <TokenCostBadge cost={cost} free={free} balance={balance} />
        : <span className="text-[11px] font-semibold" style={{ color: '#fbbf24' }}>Comprar tokens →</span>}
    </button>
  );
};

export default ConsultCard;
